module.exports = __webpack_public_path__ + "img/SketchPng208f23611beaf8ff03e76eeaca76a87583afe90e0b477ec41f3779bf5caebe27.e3cb7363.png";